import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmojiYellowBigsmile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24 48C37.2546 48 48 37.2546 48 24C48 10.7454 37.2546 0 24 0C10.7454 0 0 10.7454 0 24C0 37.2546 10.7454 48 24 48Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2692 18.3895C14.2692 21.0275 12.1281 23.1686 9.49008 23.1686C6.85204 23.1686 4.71094 21.0275 4.71094 18.3895C4.71094 15.7515 6.85204 13.6104 9.49008 13.6104C12.1281 13.6104 14.2692 15.7484 14.2692 18.3895Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.34888 16.5399C9.34888 17.316 8.72004 17.9448 7.94397 17.9448C7.1679 17.9448 6.53906 17.316 6.53906 16.5399C6.53906 15.7638 7.1679 15.135 7.94397 15.135C8.72004 15.135 9.34888 15.7638 9.34888 16.5399Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8892 18.7548C10.8892 19.2026 10.5272 19.5646 10.0793 19.5646C9.63149 19.5646 9.26953 19.2026 9.26953 18.7548C9.26953 18.3069 9.63149 17.9449 10.0793 17.9449C10.5272 17.9449 10.8892 18.3069 10.8892 18.7548Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.2887 18.3895C43.2887 21.0275 41.1507 23.1686 38.5096 23.1686C35.8685 23.1686 33.7305 21.0275 33.7305 18.3895C33.7305 15.7515 35.8685 13.6104 38.5096 13.6104C41.1507 13.6104 43.2887 15.7484 43.2887 18.3895Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.3684 16.5399C38.3684 17.316 37.7396 17.9448 36.9635 17.9448C36.1874 17.9448 35.5586 17.316 35.5586 16.5399C35.5586 15.7638 36.1874 15.135 36.9635 15.135C37.7396 15.135 38.3684 15.7638 38.3684 16.5399Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.9087 18.7548C39.9087 19.2026 39.5467 19.5646 39.0989 19.5646C38.651 19.5646 38.2891 19.2026 38.2891 18.7548C38.2891 18.3069 38.651 17.9449 39.0989 17.9449C39.5467 17.9449 39.9087 18.3069 39.9087 18.7548Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9219 27.2422C12.9219 28.5858 11.4587 29.6747 9.64884 29.6747C7.83903 29.6747 6.37891 28.5858 6.37891 27.2422C6.37891 25.8986 7.8421 24.8097 9.64884 24.8097C11.4556 24.8097 12.9219 25.8986 12.9219 27.2422Z",
			fill: "#1DBADF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.6211 27.2422C41.6211 28.5858 40.1548 29.6747 38.3511 29.6747C36.5474 29.6747 35.0781 28.5858 35.0781 27.2422C35.0781 25.8986 36.5444 24.8097 38.3511 24.8097C40.1579 24.8097 41.6211 25.8986 41.6211 27.2422Z",
			fill: "#1DBADF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9989 28.8069C26.5603 28.8069 28.8548 29.81 30.4069 31.3989C31.2229 30.4695 31.8732 29.3652 32.3057 28.1382C32.8486 26.5983 31.9069 24.8959 30.502 24.8959H17.4928C16.091 24.8959 15.1462 26.5983 15.6922 28.1382C16.1247 29.3621 16.775 30.4695 17.591 31.3989C19.1431 29.8131 21.4376 28.8069 23.9989 28.8069Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.0017 34.3864C26.5171 34.3864 28.7901 33.2392 30.4097 31.3956C28.8576 29.8097 26.5631 28.8066 24.0017 28.8066C21.4404 28.8066 19.1459 29.8097 17.5938 31.3956C19.2134 33.2392 21.4833 34.3864 24.0017 34.3864Z",
			fill: "#FF2180"
		})
	]
});
export default SvgEmojiYellowBigsmile;
